export class AssignmentContract {
  private readonly blob: Blob;
  private readonly defaultMessage: string;

  constructor(blob: any) {
    this.blob = blob;
    this.defaultMessage = 'No content found for this contract';
  }

  public get legend(): string {
    return this.defaultMessage;
  }

  public get content(): Blob {
    return this.blob;
  }
}
